// extracted by mini-css-extract-plugin
export var button = "_jq-0";
export var donut = "_jq-1";
export var donutFill = "_jq-3";
export var donutTrack = "_jq-2";